import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, interval, firstValueFrom } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { baseUrl, intUrl, localUrl, opeUrl, opewafUrl ,opeNewwafUrl} from './app.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import jwtDecode from 'jwt-decode';
import { ConfigService } from './_service/config.service';
import { Router } from '@angular/router';

const ONE_MINUTE_MS = 60000;
const TEN_MINUTES = 10;
const SECONDS_PER_MINUTE = 60;
const MILLISECONDS_PER_SECOND = 1000;

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  readonly doneAuthenticatingSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  dataConfig: any;
  refreshPopUp: boolean=false;
  showPopUp: boolean = true;

  constructor(private http: HttpClient, public  configService: ConfigService,private router:Router) {
   }

  
  loginInit(openInNewTab: boolean = false){
    localStorage.setItem("rolechange",'true')
    this.dataConfig = this.configService.getConfig();

    // Check if config is loaded properly
    if (!this.dataConfig || !Array.isArray(this.dataConfig) || this.dataConfig.length === 0 || !this.dataConfig[0].OIDC_CLIENT_ID) {
      console.error('Configuration not loaded properly or OIDC_CLIENT_ID is missing');
      console.error('dataConfig:', this.dataConfig);
      alert('Configuration error: Unable to load OAuth client ID. Please refresh the page.');
      return;
    }

    localStorage.setItem('loginInit',"true");
   let authUrl= "https://sso-uat.renault.com/oauth2/austwoeshbCkPJyw1416/v1/authorize?response_type=code" 
   let clientid=this.dataConfig[0].OIDC_CLIENT_ID;
   
   // Explicitly check for template string literal
   if (clientid.includes('${') || clientid.includes('}')) {
     console.error('CRITICAL: Client ID contains template literal string:', clientid);
     alert('Configuration error: Invalid client ID detected. The env.json file should not be used for local development. Please clear your browser cache and reload.');
     return;
   }
   
   console.info('Using OAuth client_id:', clientid);
  if (baseUrl === opeUrl || baseUrl === opewafUrl ||baseUrl === opeNewwafUrl){
    authUrl="https://sso.renault.com/oauth2/aus133y6mks4ptDss417/v1/authorize?response_type=code"
  }
    let redirect_uri= encodeURIComponent(`${baseUrl}/auth/oidc`)
     let fullUrl = `${authUrl}&scope=openid%20email%20alliance_profile%20apis.default%20legacy%20offline_access&client_id=${clientid}&state=Nt93oW45JBLzLG3sLQVnBdMwblY&redirect_uri=${redirect_uri}`;

     if (openInNewTab) {
       // Set flag in localStorage so the new tab knows to close after authorization
       localStorage.setItem('silentRefreshInProgress', 'true');
       window.open(fullUrl, '_blank');
     } else {
       window.location.href = fullUrl;
     }

   }

  logoutSession(token: string){
    if(token!=null && token != undefined && token!=''){
    this.dataConfig = this.configService.getConfig();
    
    // Check if config is loaded properly
    if (!this.dataConfig || !Array.isArray(this.dataConfig) || this.dataConfig.length === 0 || !this.dataConfig[0].OIDC_CLIENT_ID) {
      console.error('Configuration not loaded properly or OIDC_CLIENT_ID is missing');
      return;
    }
    
    let authUrl= "https://sso-uat.renault.com/oauth2/austwoeshbCkPJyw1416/v1/logout?id_token_hint=" 
   let clientid=this.dataConfig[0].OIDC_CLIENT_ID;
    let redirect_uri= encodeURIComponent(`${baseUrl}/logout`)
    if (baseUrl === opeUrl || baseUrl === opewafUrl || baseUrl== opeNewwafUrl){
      authUrl="https://sso.renault.com/oauth2/aus133y6mks4ptDss417/v1/logout?id_token_hint="
    }  
    window.location.href=`${authUrl}${token}&post_logout_redirect_uri=${redirect_uri}`;
    this.refreshPopUp=true
  }else{
    this.router.navigateByUrl('/logout');
  }
  }

   getAuthToken(code:String){
    let baseUrl1 = baseUrl
    if (baseUrl1 == localUrl || baseUrl1 == `${localUrl}/`) {
      baseUrl1 = intUrl
    }
    let datas = {
      "code": code,
      "redirect_uri": baseUrl== localUrl ? baseUrl: baseUrl 
    }
    return this.http.post(`${baseUrl1}/api/AuthToken`, datas);
  }
  getrefreshToken(code:String){
    let baseUrl1 = baseUrl
    if (baseUrl1 == localUrl || baseUrl1 == `${localUrl}/`) {
      baseUrl1 = intUrl
    }
    let datas = {
      "code": code,
      "redirect_uri": baseUrl== localUrl ? baseUrl: baseUrl 
    }
    return this.http.post(`${baseUrl1}/api/refreshToken`, datas);
  }
   public whenDoneAuthenticating(): Observable<boolean> {
    return this.doneAuthenticatingSubject.asObservable().pipe(
      filter((isDone: boolean) => isDone),
      first()
    );
  }

  public getUser(){
    try {
      const token = localStorage.getItem("IDPIdToken");
      if (!token) {
        return null;
      }
      return { userinfo: jwtDecode(token) };
    } catch (error) {
      console.error("Error decoding JWT token:", error);
      return null;
    }
//    let user:any = { "userinfo" :{
//     "sub": "00uscd2q7lDAWeQJL417",
//     "email": "tibor@clerdouet.fr",
//     "ver": 1,
//     "iss": "https://sso-uat.renault.com/oauth2/austwoeshbCkPJyw1416",
//     "aud": "irn-71016_uat_code_etzf1u2l2ltg",
//     "iat": 1768593652,
//     "exp": 1768597252,
//     "jti": "ID.GRbe2jOUlVypDsgvKqDNpY5AIiIiLs4DBc0eZetZzuI",
//     "amr": [
//         "otp"
//     ],
//     "idp": "00o8lz18qRshzA3Rj416",
//     "auth_time": 1768593650,
//     "at_hash": "0AmGYqWmhHroksXii_izPQ",
//     "identitySourceId": "PER25071754",
//     "identitySource": "CUR",
//     "lastName": "SUPPLIER",
//     "firstName": "Tibar",
//     "mail": "tibor@clerdouet.fr",
//     "displayName": "Tibar SUPPLIER",
//     "roles": [
//         "Supplier"
//     ],
//     "perimeter": "None",
//     "language": "en_US",
//     "login": "agilite.phi.5v@icloud.com",
//     "personType": "prospectSupplier"
// }
// }
      //fOR SUPPLIER
    //    let user:any= {  "userinfo": {
    //     "sub": "00u4fvhkikWkrHIrx417",
    //     "email": "tibor.clerdouet@sogeti.com",
    //     "email_verified": true,
    //     "siteSource": "RFF",
    //     "lastName": "Supplier",
    //     "personalUniqueId": "0000DSNV",
    //     "preferredLanguage": "en",
    //     "mail": "tibor.clerdouet@sogeti.com",
    //     "displayName": "Supplier Tibor",
    //     "roles": [
    //       "Supplier"
    //     ],
    //     "siteName": "REGULPROV LYON",
    //     "language": "en_FR",
    //     "login": "f062744",
    //     "title": "Supplier",
    //     "siteSourceId": "site99999901",
    //     "firstName": "Tibor",
    //     "countryCode": "FR",
    //     "perimeter": "None",
    //     "userType": "B2B_Supplier",
    //     "personType": "catf1gr"
    //   }
    // }
    // return user;
  }
public async refreshAuthToken(){
  let code=  localStorage.getItem( 'OKTARefreshToken')
  const userToken = await firstValueFrom(this.getrefreshToken(code));
}

isTokenExpired(token: string): boolean {
  try {
    const decodedToken: any = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / MILLISECONDS_PER_SECOND);
    return decodedToken.exp <= currentTime;
  } catch (error) {
    console.error('Invalid token:', error);
    return true;
  }
}
getRefreshTokenTimer(){
 
  interval(ONE_MINUTE_MS).subscribe(() => {
    let baseUrl1 = baseUrl
    if (baseUrl1 == localUrl || baseUrl1 == `${localUrl}/`) {
      baseUrl1 = intUrl;
    }
    let twentyMinutesLater = new Date();
    let minNow = twentyMinutesLater.getMinutes();
    let curentmni =twentyMinutesLater.setMinutes(minNow + TEN_MINUTES);
    if(this.refreshPopUp == false){
    const idpExpiredTime = localStorage.getItem('IDPexpiredtime');
    if (idpExpiredTime && parseInt(idpExpiredTime) <= curentmni) {
      console.info("refresh token");
      this.refreshingPage(); // Open in new tab for token refresh
    }
    let twentyMinutesLater1 = new Date();
    const accessToken = localStorage.getItem('accessToken');
    if(accessToken && this.isTokenExpired(accessToken)){
      let token = localStorage.getItem("IDPAccessToken");
     let httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
      };
      this.http.get(`${baseUrl1}/api/access_token`,httpOptions).subscribe((Acc_token: any) => {
        console.info("token --->3", Acc_token);
        let frmTime = Math.round((Acc_token.expires_in) / SECONDS_PER_MINUTE);
        let thirtymin = twentyMinutesLater1.setMinutes(twentyMinutesLater1.getMinutes() + frmTime);
        localStorage.setItem('accessToken', Acc_token.access_token);
        localStorage.setItem("expiredtime", JSON.stringify(thirtymin));
        localStorage.setItem("expiresMin", `TIME ${frmTime}`);        
      },_error =>{
      window.location.reload();
      })
    }
  }
  });

}
  public decodejwt(token:string){
    return jwtDecode(token)
  }

  refreshingPage(newTab:boolean=false): void {
  const refreshToken = localStorage.getItem('OKTARefreshToken')
  if (!refreshToken) {
    this.loginInit(newTab);
    return;
  }
  this.getrefreshToken(refreshToken).subscribe(userToken => {
    if (userToken) {
      if (userToken['res']['error'] == null || userToken['res']['error'] == undefined) {
        const IDPIdToken = jwtDecode(userToken['res']['token']['id_token']);
        console.info("IPD EXPIRES INITAL TIME SETTING");
        let twentyMinutesLater2 = new Date();
        let idpExpTime = (IDPIdToken['exp'] - IDPIdToken['iat']) / SECONDS_PER_MINUTE;
        let IDPthirtyMin = twentyMinutesLater2.setMinutes(twentyMinutesLater2.getMinutes() + idpExpTime);
        console.info("exp time : ", idpExpTime);
        console.info('user', userToken)
        localStorage.setItem("IDPAccessToken", userToken['res']['token']['access_token']);
        localStorage.setItem("IDPIdToken", userToken['res']['token']['id_token']);
        localStorage.setItem("IDPexpiredtime", JSON.stringify(IDPthirtyMin));
        localStorage.setItem("IDPexpiredMinutes", JSON.stringify(idpExpTime));
        localStorage.setItem("OKTARefreshToken", userToken['res']['token']['refresh_token']);
        let baseUrl1 = baseUrl
        if (baseUrl1 == localUrl || baseUrl1 == `${localUrl}/`) {
          baseUrl1 = intUrl;
        }
        let twentyMinutesLater = new Date();
        let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
        if(this.isTokenExpired(localStorage.getItem('accessToken'))){
          let token = localStorage.getItem("IDPAccessToken");
         let httpOptions = {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            }),
          };
          this.http.get(`${baseUrl1}/api/access_token`,httpOptions).subscribe((Acc_token: any) => {
            console.info("token --->3", Acc_token);
            let frmTime = Math.round((Acc_token.expires_in) / SECONDS_PER_MINUTE);
            let thirtymin = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes() + frmTime);
            localStorage.setItem('accessToken', Acc_token.access_token);
            localStorage.setItem("expiredtime", JSON.stringify(thirtymin));
            localStorage.setItem("expiresMin", `TIME ${frmTime}`);        
          },_error =>{
          window.location.reload();
          })
        }
      } else {
        this.loginInit(true)
      }
    } else {
      this.loginInit(newTab)
    }
  }, () => {
    this.loginInit(newTab);
  });

}

}